export const CHAT_LIBRARY_SCOPE_ALL = 'all';
export const CHAT_LIBRARY_SCOPE_RECENT = 'recent';
export const CHAT_LIBRARY_SORT_NEWEST = 'newest';
export const CHAT_LIBRARY_SORT_OLDEST = 'oldest';
export const CHAT_LIBRARY_RECENT_DAYS = 14;

export function sessionTitle(session) {
  return String(session?.title || '').trim() || 'Untitled chat';
}

export function sessionTimestamp(session) {
  const value = session?.updated_at || session?.created_at;
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.getTime();
}

export function formattedSessionDate(session) {
  const value = session?.updated_at || session?.created_at;
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function filterChatSessions(sessions, query) {
  const normalized = String(query || '').trim().toLocaleLowerCase();
  if (!normalized) return sessions;
  return sessions.filter((session) => {
    const searchable = `${sessionTitle(session)} ${session?.last_message_preview || ''} ${session?.search_text || ''}`.toLocaleLowerCase();
    return searchable.includes(normalized);
  });
}

export function filterChatSessionsByScope(sessions, scope, now = Date.now()) {
  if (scope !== CHAT_LIBRARY_SCOPE_RECENT) return sessions;
  const cutoff = now - CHAT_LIBRARY_RECENT_DAYS * 24 * 60 * 60 * 1000;
  return sessions.filter((session) => {
    const timestamp = sessionTimestamp(session);
    return timestamp != null && timestamp >= cutoff;
  });
}

export function sortChatSessions(sessions, sortOrder = CHAT_LIBRARY_SORT_NEWEST) {
  const sorted = [...sessions].sort((left, right) => {
    const leftTimestamp = sessionTimestamp(left) ?? 0;
    const rightTimestamp = sessionTimestamp(right) ?? 0;
    return rightTimestamp - leftTimestamp;
  });
  if (sortOrder === CHAT_LIBRARY_SORT_OLDEST) {
    return sorted.reverse();
  }
  return sorted;
}

export function applyChatLibraryFilters(
  sessions,
  { query = '', scope = CHAT_LIBRARY_SCOPE_ALL, sortOrder = CHAT_LIBRARY_SORT_NEWEST, now } = {}
) {
  const scoped = filterChatSessionsByScope(sessions, scope, now);
  const searched = filterChatSessions(scoped, query);
  return sortChatSessions(searched, sortOrder);
}

export function chatSessionCountLabel(count, limit = 50) {
  if (count === limit) return `Showing ${limit} most recent chats`;
  return `${count} ${count === 1 ? 'chat' : 'chats'}`;
}
